import { useDrawer } from '@looker/components';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { AIChat } from './components/AIChat';

interface AIContextData {
  isChatOpen: boolean;
  showChat: () => void;
  hideChat: () => void;
  activeChatId: number | null;
  setActiveChatId: (chatId: number | null) => void;
}

const AIContext = createContext<AIContextData>({} as AIContextData);

export const AIContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    dialog,
    isOpen: isChatOpen,
    setOpen,
  } = useDrawer({ content: <AIChat onClose={() => setOpen(false)} />, width: '540px' });

  const [activeChatId, setActiveChatId] = useState<number | null>(14);

  const showChat = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const hideChat = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const contextValue: AIContextData = useMemo(
    () => ({
      isChatOpen,
      showChat,
      hideChat,
      activeChatId,
      setActiveChatId,
    }),
    [isChatOpen, showChat, hideChat, activeChatId],
  );

  return (
    <AIContext.Provider value={contextValue}>
      {children}
      {dialog}
    </AIContext.Provider>
  );
};

export const useAIContext = () => {
  return useContext(AIContext);
};
